const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

const states = {
  'Alta Verapaz': 'Alta Verapaz',
  'Baja Verapaz': 'Baja Verapaz',
  Chimaltenango: 'Chimaltenango',
  Chiquimula: 'Chiquimula',
  'El Peten': 'El Peten',
  'El Progreso': 'El Progreso',
  Escuintla: 'Escuintla',
  Guatemala: 'Guatemala',
  Huehuetenango: 'Huehuetenango',
  Izabal: 'Izabal',
  Jalapa: 'Jalapa',
  Jutiapa: 'Jutiapa',
  Quetzaltenango: 'Quetzaltenango',
  Quiche: 'Quiche',
  Retalhuleu: 'Retalhuleu',
  Sacatepequez: 'Sacatepequez',
  'San Marcos': 'San Marcos',
  'Santa Rosa': 'Santa Rosa',
  Solola: 'Solola',
  Suchitepequez: 'Suchitepequez',
  Totonicapan: 'Totonicapan',
  'Zacapa ': 'Zacapa'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Guatamala',
  code: 'GT',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'Department',
      width: 0.5
    },
    zipCode: {
      label: 'Zip Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 09001'
    }
  ]
};
